/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_UrlInputs */

const en_booking_url = /** @type {(inputs: Booking_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking URL`)
};

const es_booking_url = /** @type {(inputs: Booking_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de Reserva`)
};

const fr_booking_url = /** @type {(inputs: Booking_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de réservation`)
};

const de_booking_url = /** @type {(inputs: Booking_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungs-URL`)
};

const id_booking_url = /** @type {(inputs: Booking_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Pemesanan`)
};

/** @type {(inputs: Booking_UrlInputs) => LocalizedString} */
const ja_booking_url = en_booking_url;

/** @type {(inputs: Booking_UrlInputs) => LocalizedString} */
const zh_booking_url = en_booking_url;

/** @type {(inputs: Booking_UrlInputs) => LocalizedString} */
const ar_booking_url = en_booking_url;

/** @type {(inputs: Booking_UrlInputs) => LocalizedString} */
const it_booking_url = en_booking_url;

/** @type {(inputs: Booking_UrlInputs) => LocalizedString} */
const ru_booking_url = en_booking_url;

/** @type {(inputs: Booking_UrlInputs) => LocalizedString} */
const pt_booking_url = en_booking_url;

/** @type {(inputs: Booking_UrlInputs) => LocalizedString} */
const ko_booking_url = en_booking_url;

/**
* | output |
* | --- |
* | "Booking URL" |
*
* @param {Booking_UrlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_url = /** @type {((inputs?: Booking_UrlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_UrlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_url(inputs)
	if (locale === "es") return es_booking_url(inputs)
	if (locale === "fr") return fr_booking_url(inputs)
	if (locale === "de") return de_booking_url(inputs)
	if (locale === "ja") return ja_booking_url(inputs)
	if (locale === "zh") return zh_booking_url(inputs)
	if (locale === "ar") return ar_booking_url(inputs)
	if (locale === "id") return id_booking_url(inputs)
	if (locale === "it") return it_booking_url(inputs)
	if (locale === "ru") return ru_booking_url(inputs)
	if (locale === "pt") return pt_booking_url(inputs)
	return ko_booking_url(inputs)
});